export default __webpack_public_path__ + "static/media/error404.e5d647f0.svg";